var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#656565",
    d: "M10 15.667H6C2.38 15.667.833 14.12.833 10.5v-4C.833 2.88 2.38 1.333 6 1.333h4c3.62 0 5.167 1.547 5.167 5.167v4c0 3.62-1.547 5.167-5.167 5.167M6 2.333c-3.073 0-4.167 1.094-4.167 4.167v4c0 3.073 1.094 4.167 4.167 4.167h4c3.073 0 4.167-1.094 4.167-4.167v-4c0-3.073-1.094-4.167-4.167-4.167z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#656565",
    d: "M4.887 10.66a.5.5 0 0 1-.307-.107.5.5 0 0 1-.093-.7l1.586-2.06a1.17 1.17 0 0 1 1.647-.206l1.22.96c.047.04.093.04.127.033.026 0 .073-.013.113-.067l1.54-1.986a.493.493 0 0 1 .7-.087c.22.167.26.48.087.7l-1.54 1.987a1.14 1.14 0 0 1-.78.44c-.314.04-.62-.047-.867-.24l-1.22-.96a.15.15 0 0 0-.127-.034c-.026 0-.073.014-.113.067l-1.587 2.06a.45.45 0 0 1-.386.2"
  })));
};
export default SvgActivity;